"use client";
import Link from "next/link";
import { ArrowRight, TrendingUp } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { whyContact as data } from "@/lib/data/contact";

const accent = "var(--color-cyan)";

export function WhyContact() {
  return (
    <Section id="why-contact" className="relative">
      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-cyan)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
            <p className="mt-5 text-body text-[rgb(var(--fg-muted))] leading-relaxed">{data.intro}</p>
          </div>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 gap-5">
          <Reveal delay={100}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <span className="eyebrow-tiny font-bold" style={{ color: accent }}>What Distinguishes Our Engagement</span>
              <div className="mt-4 space-y-3">
                {data.whatDistinguishes.map((w) => (
                  <div key={w.title} className="text-sm">
                    <div className="font-semibold" style={{ color: accent }}>{w.title}</div>
                    <div className="text-[rgb(var(--fg-muted))] mt-0.5 leading-relaxed">{w.body}</div>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
          <Reveal delay={150}>
            <div className="glass rounded-2xl p-6 h-full" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
              <div className="flex items-center gap-3">
                <span className="grid place-items-center h-10 w-10 rounded-lg" style={{ background: `color-mix(in oklch, ${accent} 18%, transparent)`, boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)` }}>
                  <TrendingUp className="h-4 w-4" style={{ color: accent }} />
                </span>
                <span className="eyebrow-tiny font-bold" style={{ color: accent }}>Client Outcomes</span>
              </div>
              <ul className="mt-4 space-y-2">
                {data.clientOutcomes.map((o, i) => (
                  <li key={i} className="flex items-baseline gap-2 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                    <span className="font-semibold" style={{ color: accent }}>{o}</span>
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
        <Reveal delay={200}>
          <div className="mt-8 glass rounded-2xl p-6" style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 18%, transparent)` }}>
            <span className="eyebrow-tiny font-bold" style={{ color: accent }}>{data.difference.title}</span>
            <p className="mt-3 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">{data.difference.body}</p>
          </div>
        </Reveal>
        <Reveal delay={400}>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            {data.cta.map((c, i) => (
              <Link key={c.label} href={c.href} className={i === 0 ? "btn-primary-gradient h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm" : "btn-glass h-11 px-6 inline-flex items-center gap-2 rounded-full font-semibold text-sm"}>
                {c.label} <ArrowRight className="h-3.5 w-3.5" />
              </Link>
            ))}
          </div>
        </Reveal>
      </Container>
    </Section>
  );
}
